module.exports = __webpack_public_path__ + "media/images/web_suite/resources_thumbs/featured-learn-site-thumbnail_en-e6c0fda5f004360eb8857218be51b0e6.png";